import React from 'react';
import { useRouter } from '@uirouter/react';
import { SimpleSidebar } from '@adjust/dashboard-components';

import { SidebarId } from '@react/constants/sidebars';
import { TwoFactorConfigurationContainer } from './TwoFactorConfiguration.container';

interface TwoFactorAuthSidebarProps {
  routerProps: {
    backPath: string;
  };
}

export const TwoFactorConfigurationSidebar: React.FC<TwoFactorAuthSidebarProps> = ({ routerProps: { backPath } }) => {
  const router = useRouter();

  const onCloseHandler = () => {
    router.stateService.go(backPath);
  };

  return (
    <SimpleSidebar name={SidebarId.TwoFactorAuth} onClose={onCloseHandler}>
      {props => <TwoFactorConfigurationContainer closeSidebar={props.closeSidebar} />}
    </SimpleSidebar>
  );
};
